import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { COUNTRY_CODES } from "@/i18n/countryCodes";

// Phone field with a country-code selector on the left and the number on the
// right. Matches the same underline input aesthetic used across the site
// (transparent bg, border-b, focus:border-accent).
export function PhoneField({
  countryIso,
  onCountryChange,
  number,
  onNumberChange,
  testId = "phone",
  inputClass = "",
}) {
  const selected = COUNTRY_CODES.find((c) => c.iso === countryIso) || COUNTRY_CODES[0];

  return (
    <div className="flex items-stretch gap-3">
      <Select value={countryIso} onValueChange={onCountryChange}>
        <SelectTrigger
          data-testid={`${testId}-country-trigger`}
          className="w-[130px] rounded-none border-0 border-b border-borderline bg-transparent px-0 py-3 text-base text-ink focus:ring-0 focus:border-accent transition-colors duration-300"
        >
          <SelectValue>
            <span className="font-mono text-sm tracking-tight">
              <span className="mr-1.5">{selected.flag}</span>
              {selected.dial}
            </span>
          </SelectValue>
        </SelectTrigger>
        <SelectContent className="max-h-[320px] bg-paper text-ink border-borderline">
          {COUNTRY_CODES.map((c) => (
            <SelectItem
              key={`${c.iso}-${c.dial}`}
              value={c.iso}
              data-testid={`${testId}-country-option-${c.iso}`}
              className="font-body text-sm"
            >
              <span className="mr-2">{c.flag}</span>
              <span className="font-mono">{c.dial}</span>
              <span className="ml-3 text-secondary">{c.name}</span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Input
        type="tel"
        inputMode="tel"
        autoComplete="tel-national"
        value={number}
        onChange={(e) => onNumberChange(e.target.value)}
        data-testid={`${testId}-input`}
        className={`flex-1 ${inputClass}`}
      />
    </div>
  );
}
